import type { Configuration } from 'modules/integrations/public'
import i18n from 'modules/core/lib/i18n'

import { employeeUpdatesLeaveSyncIssuesByKey } from './syncIssuesByKey'

export const EMPLOYEE_UPDATES_LEAVE_SYNC_CONFIGURATION: Configuration = {
  origin: 'employeeupdates',
  syncableType: 'employeeupdatesleave',
  syncableEntityName: () => i18n.t('payroll_integrations.employee_update_leave.sync_entity_name'),
  issuesByKey: employeeUpdatesLeaveSyncIssuesByKey,
}
